/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Page Cashback actions
 *
 * @author Yakov Gushchin
 * @version 1.13.1
 * @since 1.12.0
 */
import { IOptionItemProps } from '../../../components/common/Select/Select';
import { createAction } from '../../../modules/app/createAction';
import {
    CASHBACK_GET_ACCOUNT_LIST_FAILURE,
    CASHBACK_GET_ACCOUNT_LIST_START,
    CASHBACK_GET_ACCOUNT_LIST_SUCCESS,
    CASHBACK_GET_META_FAILURE,
    CASHBACK_GET_META_START,
    CASHBACK_GET_META_SUCCESS,
    CASHBACK_SET_ACCOUNT,
} from '../pageCashbackConstants';
import {
    ICashbackGetAccountListStartPayload,
    ICashbackGetMetaStartPayload,
    TCashbackGetAccountListFailureAction,
    TCashbackGetAccountListStartAction,
    TCashbackGetAccountListSuccessAction,
    TCashbackGetAccountListSuccessPayload,
    TCashbackGetMetaFailureAction,
    TCashbackGetMetaStartAction,
    TCashbackGetMetaSuccessAction,
    TCashbackGetMetaSuccessPayload,
    TCashbackSetAccountAction,
} from '../types/cashbackTypes';

/*
* -------------------------------------------
*          Get Cashback Meta
* -------------------------------------------
*/

export const cashbackGetMetaStartAction = (payload: ICashbackGetMetaStartPayload): TCashbackGetMetaStartAction =>
    createAction(CASHBACK_GET_META_START, payload);

export const cashbackGetMetaSuccessAction = (payload: TCashbackGetMetaSuccessPayload):
    TCashbackGetMetaSuccessAction => createAction(CASHBACK_GET_META_SUCCESS, payload);

export const cashbackGetMetaFailedAction = (payload: string): TCashbackGetMetaFailureAction =>
    createAction(CASHBACK_GET_META_FAILURE, payload);

/*
* -------------------------------------------
*          Cashback Account Select
* -------------------------------------------
*/

export const cashbackGetAccountListStartAction = (payload: ICashbackGetAccountListStartPayload):
    TCashbackGetAccountListStartAction => createAction(CASHBACK_GET_ACCOUNT_LIST_START, payload);

export const cashbackGetAccountListSuccessAction = (payload: TCashbackGetAccountListSuccessPayload):
    TCashbackGetAccountListSuccessAction => createAction(CASHBACK_GET_ACCOUNT_LIST_SUCCESS, payload);

export const cashbackGetAccountListFailureAction = (payload: string):
    TCashbackGetAccountListFailureAction => createAction(CASHBACK_GET_ACCOUNT_LIST_FAILURE, payload);


export const cashbackSetAccountAction = (payload: IOptionItemProps):
    TCashbackSetAccountAction => createAction(CASHBACK_SET_ACCOUNT, payload);
